// @ts-nocheck
/* eslint-disable */
export const searchIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="none"><path d="M10.1963 15.3926L6.94629 21.0217" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1962 15.3923C13.0659 17.0492 16.7355 16.0659 18.3923 13.1962C20.0492 10.3264 19.0659 6.65685 16.1962 5C13.3264 3.34315 9.65685 4.3264 8 7.19615C6.34315 10.0659 7.3264 13.7355 10.1962 15.3923Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'search' as const,
};
